<h1 mat-dialog-title>{{title | translate}}</h1>
<div mat-dialog-content class="mat-typography">
  <p>{{body | translate}}</p>
</div>
<div mat-dialog-actions>
  <button mat-button mat-dialog-close="ok" cdkFocusInitial>{{okLabel | translate}}</button>
  @if (!!data.actionLabel) {
    <button mat-button mat-dialog-close="action">{{data.actionLabel | translate}}</button>
  }
</div>
